import { iconsSet } from "../../../../assets/icons/icons";
import defaultContent from "../default";
export default {
  hero: {
    img: {
      url: "https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_newbot.png",
      alt: "Estratégias Newbot",
    },
    title: "Opere com a Newbot",

    // String ou array de strings
    text: [
      "Com mais de 10 anos de experiência em robôs e automatização, nossos produtos são pensandos para superar suas expectativas trazendo disciplina, gestão de risco e diversificação pra seus trades.",
      "Para nós, você é a prioridade! Não com dúvidas, venha para Newbot!",
    ],
    testimonial: {
      text: "Transparência, solidez, eficiência e inovação: esses são os pilares da Newbot.",
      author: {
        name: "Edson Jr., Head de Estratégias Newbot",
        picture:
          "https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/foto-edson-3-150x150.jpg",
      },
    },
  },
  stats: {
    title: "Alguns números da Newbot",
    subtitle:
      "Mais de 10 anos de experiência operando de forma automatizada em escala global.",
    data: [
      {
        value: "+10",
        description: "Anos em atividade",
      },
      {
        value: "+3k",
        description: "Clientes satisfeitos",
      },
      {
        value: "+8M",
        description: "Ordens executadas por ano",
      },
    ],
  },
  features: {
    title: "Por que utilizar os robôs da Newbot?",
    subtitle: "Veja quais as principais vantagens dos robôs da Newbot.",
    data: [
      {
        icon: iconsSet.calendar,
        title: "7 dias para testar",
        description:
          "Teste nossas estratégias e confira a performance em sua conta.",
      },
      {
        icon: iconsSet.code,
        title: "100% automatizado",
        description:
          "Realizamos todos os ajustes e parametrizações das estratégias automaticamente.",
      },
      {
        icon: iconsSet.chat,
        title: "Suporte individual",
        description:
          "Priorizamos um atendimento individual de qualidade visando sempre esclarecer as dúvidas de nossos clientes.",
      },
      ...defaultContent.features.data,
    ],
  },
  cta: {
    title: "Pronto para iniciar?",
    subtitle: "Ative agora mesmo a extensão Newbot.",
  },
  about: {
    title: "Sobre o desenvolvedor",
    subtitle: "A Newbot",
    col1: [
      "Idealizada para se adaptar as constantes mudanças do mercado financeiro, com a expertise na criação de algoritmos eficazes e lucrativos: Assim nasceu a Newbot.",
      "Utilizando algoritmos próprios que se adaptam a dinâmica do mercado, nossos robôs farão de você um investidor de sucesso.",
    ],
    col2: [
      "Formada por um time de profissionais experientes como Edson Júnior: profissional com mais de 10 anos de experiência no mercado financeiro atualmente é estrategista em operações automatizadas com diversos algoritmos proprietários e head de estrategista da Newbot.",
    ],
  },
  plans: {
    title: "Planos",
    subtitle: "Conheça os planos da extensão Newbot",
  },
  strategies: {
    title: "Estratégias Newbot",
    heading: "Algoritmos avançados à sua disposição.",
    subtitle:
      "Estratégias prontas, desenvolvidas por profissionais. Comece agora mesmo com apenas alguns cliques.",
  },
  testimonials: [
    {
      text: "A Newbot é muito mais que estratégias para robôs que realmente funcionam, é atendimento especializado, orientação plena e aprendizado. Parabéns Edson e equipe!",
      author: "Eliseu Sandres",
      job: "Bancário",
      image_url:
        "https://newbot.com.br/wp-content/uploads/2018/03/eliseu-sandres-120x120.jpg",
    },
    {
      text: "Além de possuir estratégias extremamente bem refinadas, a Newbot proporciona também conhecimento compartilhado, atendimento direto e rápido e verdadeira preocupação com seus clientes.",
      author: "Victor Nardi Vilella",
      job: "Arquiteto de Sistemas",
      image_url:
        "https://newbot.com.br/wp-content/uploads/2018/03/Victor-nardi-vilella-120x120.jpg",
    },
  ],
};
